import fetchServer from "../../fetchServer";

export default async function enableWalletPayoutOTP() {
  let result = { return: 0, msg: "Something went wrong enabling payout OTP!" };

  await fetchServer({ method: "GET", url: "/payment/v1/walletPayout/enableOTP" })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = { return: 1, msg: "Successful", data: res?.data?.data };
      } else if (res?.data?.error) result["msg"] = res.data.error;
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}
